import React from 'react'
import StyledAlert from '../../../generic/StyledAlert'

const RecipientCanOptOutMessage = () => {
  const message =
    'By clicking submit, your recipient(s) will be notified that you have added them to Arpari for future payments. They will have the ability to opt out of receiving funds from you through Arpari and we will attempt to cancel any pending payments to them.'
  return <StyledAlert message={message} marginBottom='10px' />
}

export default RecipientCanOptOutMessage
